/* eslint-disable react-hooks/exhaustive-deps */
import React, { MutableRefObject, useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { Checkbox, FormikProps, Input, Select } from 'components/form';
import { RoleData } from 'api/master/get-roles.api';
import { useSubscription } from 'hooks/use-subscription.hook';
import { uploadImg } from 'api/common/upload-img.api';
import { MyProfile } from 'api/auth/user-profile';
import PasswordHidden from '../password-hidden';
import { REGEX_PATTERN, Role } from 'consts/common.const';
import { UserData } from 'api/user/get-users.api';
import { useFormikContext } from 'formik';

interface AddUserProps {
  isEdit?: boolean;
  isProfile?: boolean;
  isAdd?: boolean;
  avatar?: string;
  data?: MyProfile;
  roles?: RoleData[];
  users?: UserData[];
  formikRef: MutableRefObject<FormikProps<any>>;
  setRoleField?: (...agr) => void;
  setReflectData?: (...agr) => void;
}

function AddUser({
  isEdit,
  roles,
  formikRef,
  users,
  isProfile,
  avatar,
  isAdd,
  setRoleField,
  setReflectData,
}: AddUserProps) {
  const [previewAvatar, setPreviewAvatar] = useState<string>();
  const formik: any = useFormikContext();

  const fileAvatarRef = useRef<HTMLInputElement>();
  const subscription = useSubscription();
  const { t } = useTranslation();
  const [checkListOption, setCheckListOption] = useState(false);
  const [valueItemOption, setValueItemOption] = useState('');

  useEffect(() => {
    if (isAdd || isEdit) {
      setRoleField(formik?.values?.role);
    }

    if (isProfile) {
      setReflectData(formik?.values);
    }
  }, [formik?.values]);

  const handleClickImage = (e: React.MouseEvent) => {
    e.preventDefault();
    fileAvatarRef.current.click();
  };

  const handleChangeAvatar = (e: React.ChangeEvent) => {
    const files = (e.target as HTMLInputElement).files;

    if (files[0].size) {
      const upload = uploadImg({
        file: files[0],
      }).subscribe((res) => {
        formikRef.current.setFieldValue('pathAvatar', res.data);

        const reader = new FileReader();

        reader.onloadend = () => setPreviewAvatar(reader.result as string);
        reader.readAsDataURL(files[0]);
      });

      subscription.add(upload);
    } else {
      setPreviewAvatar(null);
    }
  };

  useEffect(() => {
    // select
    const optionElement = Array.from(
      document.querySelectorAll(
        '.form-add-edit-select .form-control-wrap-select > div > div:nth-child(1) > div:nth-child(2)'
      ) || []
    ).filter((item) => !item.getAttribute('class').includes('option'));
    const NameElement = document.querySelectorAll('.name-lable-add');

    const ListElement = document.querySelectorAll('.form-add-edit-select .form-control-wrap-select > div');

    optionElement.forEach((item, idx) => {
      item.setAttribute(
        'data-id',
        (NameElement[idx] as HTMLElement)?.innerText
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
      );
    });

    const blockListElement = Array.from(ListElement || [])
      .find((item) => item.getAttribute('class').includes('menu'))
      ?.querySelector('div').children;

    Array.from(blockListElement || []).forEach((item) => item.setAttribute('data-id', valueItemOption));
  }, [checkListOption, valueItemOption]);

  const handleChangeOption = (e) => {
    setCheckListOption(!checkListOption);

    const value = 'i*' + e.target.parentElement.querySelector('div:nth-child(2)').getAttribute('data-id');

    setValueItemOption(value);
  };

  return (
    <div className='form-add-edit-select'>
      <div className='d-flex justify-content-center align-items-center flex-column'>
        {previewAvatar ? (
          <>
            <img className='user-avatar__upload' alt='avatar' src={previewAvatar} onClick={handleClickImage} />
          </>
        ) : (
          <>
            {avatar ? (
              <img className='user-avatar__upload' src={avatar} alt='avatar_user' onClick={handleClickImage} />
            ) : (
              <div className='avatar-default' onClick={handleClickImage}>
                <div className='wrapper-avatar__default'>
                  <i className='fas fa-user'></i>
                </div>
              </div>
            )}
          </>
        )}
        <div className='upload-avatar__content' onClick={handleClickImage}>
          <i className='icon-upload fas fa-upload'></i>
          <span className='upload-avatar__text'>{t('page.user.upload_avatar')}</span>
        </div>

        <input
          type='file'
          ref={fileAvatarRef}
          className='h-d_none'
          name='avatar'
          onChange={handleChangeAvatar}
          accept='image/*'
        />
      </div>

      <div className='form-group row'>
        <label className='col-sm-3 col-form-label'>
          {t('user.form.emp_name')} <span className='h-text-danger'>*</span>
        </label>
        <div className='col-sm-9'>
          <Input type='text' name='empName' />
        </div>
      </div>

      <div className='form-group row'>
        <label className='col-sm-3 col-form-label'>
          {t('page.user.label.phone_number')} <span className='h-text-danger'>*</span>
        </label>
        <div className='col-sm-9'>
          <Input type='text' name='phone' />
        </div>
      </div>

      <div className='form-group row'>
        <label className='col-sm-3 col-form-label'>
          Email <span className='h-text-danger'>*</span>
        </label>
        <div className='col-sm-9'>
          <Input type='email' name='email' />
        </div>
      </div>

      {!isAdd && (
        <div className='form-group row'>
          <label className='col-sm-3 col-form-label'>
            {t('user.form.username')} {isEdit && <span className='h-text-danger'>*</span>}
          </label>
          <div className='col-sm-9'>
            <Input type='text' name='username' disabled={isEdit || isProfile} />
          </div>
        </div>
      )}

      {!isAdd && (
        <div className='form-group row'>
          <label className='col-sm-3 col-form-label'>
            {t('page.user.old.password')} {isAdd && <span className='h-text-danger'>*</span>}
          </label>
          <div className='col-sm-9'>
            <PasswordHidden name='oldPassword' />
          </div>
        </div>
      )}

      <div className='form-group row'>
        <label className='col-sm-3 col-form-label'>
          {isAdd ? t('label.password') : t('page.sendmail.form.password')}{' '}
          {(isAdd || REGEX_PATTERN.password.test(formik.values.oldPassword)) && (
            <span className='h-text-danger'>*</span>
          )}
        </label>
        <div className='col-sm-9'>
          <PasswordHidden name='password' />
        </div>
      </div>

      <div className='form-group row'>
        <label className='col-sm-3 col-form-label'>
          {isAdd ? t('label.confirm_password') : t('label.confirm_password_new')}{' '}
          {(isAdd || REGEX_PATTERN.password.test(formik.values.oldPassword)) && (
            <span className='h-text-danger'>*</span>
          )}
        </label>
        <div className='col-sm-9'>
          <Input type='password' name='confirm_password' />
        </div>
      </div>

      {!isProfile && (
        <>
          <div className='form-group'>
            <Checkbox name='send_email' value='1' label={t('label.send_to_email')} checked={isEdit} />
          </div>
          <div className='form-group row'>
            <label className='col-sm-3 name-lable-add'>
              {t('common.label.role')} {isAdd && <span className='h-text-danger'>*</span>}
            </label>
            <div className='col-sm-9' onClick={handleChangeOption}>
              <Select
                name='role'
                options={
                  roles.length &&
                  roles
                    .filter((item) => item.roleId !== Role.ROOT)
                    .map((role) => ({ label: role.roleName, value: role.roleId }))
                }
              />
            </div>
          </div>
          {(formik.values.role === Role.SALE || formik.values.role === Role.RECER) && (
            <div className='form-group row'>
              <label className='col-sm-3 name-lable-add'>
                Chức danh {isAdd && <span className='h-text-danger'>*</span>}
              </label>
              <div className='col-sm-9' onClick={handleChangeOption}>
                <Select name='level' options={masterData('level')} />
              </div>
            </div>
          )}

          <div className='form-group row'>
            <label className='col-sm-3 name-lable-add'>{t('common.label.ownerName')}</label>
            <div className='col-sm-9' onClick={handleChangeOption}>
              <Select
                name='ownerId'
                options={[
                  { label: '', value: '' },
                  ...(users.length &&
                    users
                      .filter((item) => [Role.ADMIN, Role.AM, Role.ROOT].includes(item.role))
                      .map((role) => ({ label: role.empName, value: role.userId }))),
                ]}
              />
            </div>
          </div>
          <div className='form-group row'>
            <label className='col-sm-3 name-lable-add'>
              {t('page.user.label.status')}
              <span className='h-text-danger'>*</span>
            </label>
            <div className='col-sm-9' onClick={handleChangeOption}>
              <Select name='status' options={masterData('status')} />
            </div>
          </div>

          <div className='form-group row'>
            <label className='col-sm-3'>{t('page.user.label.date_created')}</label>
            <div className='col-sm-9'>
              <span data-id='date_created'>{dayjs().format('DD/MM/YYYY')}</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default AddUser;
